var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9748 7.19731C10.3588 6.49481 8.31461 4.36541 7.64021 1.64041L7.34981 0.467285L7.05941 1.64041C6.38501 4.36541 4.34084 6.49481 1.72483 7.19731L0.598633 7.49981L1.72483 7.80294C4.34084 8.50544 6.38501 10.6348 7.05941 13.3592L7.34981 14.5329L7.64021 13.3592C8.31461 10.6348 10.3588 8.50544 12.9748 7.80294L14.101 7.49981L12.9748 7.19731Z",
    fill: "#5D44FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4002 4.84187C11.4002 4.11562 12.1646 3.28 12.8996 3.28C12.1922 3.28 11.4002 2.43562 11.4002 1.71875C11.4002 2.43562 10.6154 3.28 9.90137 3.28C10.5884 3.28 11.4002 4.11125 11.4002 4.84187Z",
    fill: "#5D44FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_1307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssist);
export default __webpack_public_path__ + "static/media/ai-assist.43dcc9c94280cdbcb545b4b7c443d315.svg";
export { ForwardRef as ReactComponent };